/**
 * `exportar pdf` — part of the module frame on every module screen (shot `2c`),
 * not a global action.
 *
 * Rendered DISABLED on purpose. The export mechanism is undecided (§3.2: client-side
 * render vs. a backend endpoint, with the backend the likelier match for "export the
 * dashboard" faithfully). Shipping the control disabled keeps the frame's layout
 * honest — it is drawn in every shot — without inventing behaviour behind it.
 */
export function ExportarPdf() {
  return (
    <button
      type="button"
      disabled
      title="em definição — mecanismo de exportação ainda não decidido (§3.2)"
      className="rounded-control border-action-secondary-border bg-action-disabled text-action-disabled-fg cursor-not-allowed border px-5 py-2.5 type-button"
    >
      exportar pdf
    </button>
  )
}
